import styled, {
  DefaultTheme,
  FlattenInterpolation,
  ThemeProps,
  useTheme,
} from 'styled-components';

import { Box, Flex, Icon } from 'dash-ui';
import { PropertyStatusesEnum } from 'dash-common';
import { PortfoliosByPublicFolderListItemFragment } from 'gql/generated.graphql';

const Container = styled(Flex)<{
  css?: FlattenInterpolation<ThemeProps<DefaultTheme>>;
}>`
  position: absolute;
  background: linear-gradient(
    0deg,
    rgba(32, 158, 112, 0.3),
    rgba(217, 217, 217, 0.3)
  );
  top: 0;
  ${({ css }) => css}
`;

const RelativeContainer = styled(Box)`
  position: relative;
`;

const PortfolioLockMask = ({
  portfolio,
  css,
  ...args
}: {
  portfolio: PortfoliosByPublicFolderListItemFragment;
  css?: FlattenInterpolation<ThemeProps<DefaultTheme>>;
  w?: string;
  h?: string;
}) => {
  const theme = useTheme();
  const isPrivate =
    portfolio.property?.status &&
    portfolio.property.status !== PropertyStatusesEnum.PUBLIC;

  return isPrivate ? (
    <Container alignItems="center" justifyContent="center" css={css} {...args}>
      <Icon name="lock" size={56} color={theme.colors.white} />
    </Container>
  ) : null;
};

export default PortfolioLockMask;
export { RelativeContainer };
